import React, { useEffect, useState } from 'react';
import './tasksInt.css';
import TaskCardInt from './TaskCard';
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import TaskCardCompletedInt from "./taskCardCompleted";
import {useHistory} from "react-router-dom";

function TasksInt(props) {
	const { data, bottomCard, campaignOrg, scrollNav, swipeActions } = props;
	const history = useHistory();
	return (
		<>
			<div className="page-content page-content-task" {...swipeActions}>
				<div className="task-page-header">
					<h2>How to earn points?</h2>
					<p>You can earn points by doing some simple tasks and teaching your students</p>
				</div>
				<div className="task-page-cards">
					<TaskCardInt data={data} scrollNav={scrollNav} campaignOrg={campaignOrg} />
				</div>
				<TaskCardCompletedInt data={data} scrollNav={scrollNav} campaignOrg={campaignOrg}></TaskCardCompletedInt>
				<div className="task-page-bottom-cards">
					<h2>Earn more points by completing below tasks </h2>
					<p>Each Task Contain 100 points </p>
					<BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg} ></BottomCardGroupInt>
				</div>
				<div className="task-page-bottom-img">
					<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-overview-bottom-img.png" alt="overviewbottomimg" />
				</div>
				<div className="task-page-footer">
					<button className="btn-action"
						onClick={() =>{
							scrollNav(-1);
							window.scrollTo({ top: 0, behavior: 'smooth' });
						}}>Be on Top
					</button>
				</div>
			</div>
		</>
	);
}

export default TasksInt;
